export const pageAdmin = {
  HOME: '/admin',
  USER_MANAGE: '/admin/user-manage',
  RECOMMEND_CONTENTS_MANAGE: '/admin/recommend-contents-manage',
  All_CONTENTS_MANAGE: '/admin/all-contents-manage',
  TUTORIAL_CONTENTS_MANAGE: '/admin/tutorial-contents-manage',
  TUTORIAL_CONTENTS_MANAGE_CREATED: '/admin/tutorial-contents-manage/created',
  KEYWORD_MANAGE: '/admin/keyword-manage',
  GRADE_SUBJECT_MANAGE: '/admin/grade-subject-manage',
  ADVANCED: '/admin/advanced',
  NOTICE_MANAGE: '/admin/notice',
  NOTICE_MANAGE_CREATE: '/admin/notice-create',
  FAQ_MANAGE: '/admin/faq',
  EMAIL_QUESTION: '/admin/email-question',
  MEMBER_DASHBOARD: '/admin/member-dashboard',
  CONTENT_DASHBOARD: '/admin/content-dashboard',
  FAQ_MANAGE_CREATE: '/admin/faq-create',
} as const;

export const pageAdminLocale: {
  [K in keyof typeof pageAdmin]: `/:locale${typeof pageAdmin[K]}`
} = {} as any;
Object.entries(pageAdmin).forEach(([name, pagePath]) => {
  (pageAdminLocale as any)[name] = `/:locale${pagePath}`;
});
